const FormatTime = (tempo) => {
  if (!tempo) return null;
  const { hours, minutes, seconds } = tempo;

  if (!hours && !minutes && !seconds) return null;
  const pad = (num) => String(num).padStart(2, "0");

  return `${pad(hours ?? 0)}:${pad(minutes ?? 0)}:${pad(seconds ?? 0)}`;
};

export default FormatTime;
